import { createContext, useContext } from 'react';

enum PageTypeEnum {
  STAND_BY = 'STAND_BY',
  CART = 'CART',
  CART_RETAIL = 'CART_RETAIL',
  PAYMENT_PROCESSED = 'PAYMENT_PROCESSED',
}

enum ActionTypeEnum {
  UPDATE_PRODUCT = 'UPDATE_PRODUCT',
  PAGE_CHANGE = 'PAGE_CHANGE',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  SHOW_NPS = 'SHOW_NPS',
}

type CustomerDisplayUpdateProductOrPageChangeData = {
  page: PageTypeEnum
}

type CustomerDispayPaymentSuccessfulData = {
  invoice_id: string
}

type PayloadCustomerDisplay =
  | {
      type: ActionTypeEnum.UPDATE_PRODUCT | ActionTypeEnum.PAGE_CHANGE
      data: CustomerDisplayUpdateProductOrPageChangeData
    }
  | {
      type: ActionTypeEnum.PAYMENT_SUCCESSFUL
      data: CustomerDispayPaymentSuccessfulData
    }
  | {
      type: ActionTypeEnum.SHOW_NPS
    }

type Props = {
  emit: (payload: PayloadCustomerDisplay) => void
  addListener: (callback: (data: PayloadCustomerDisplay) => void) => void
}

const CustomerDisplayContext = createContext<Props>({} as Props)

const useCustomerDisplay = () => useContext(CustomerDisplayContext)

export type { PayloadCustomerDisplay }

export { PageTypeEnum, ActionTypeEnum, CustomerDisplayContext, useCustomerDisplay }
